import { usePlansStore } from '@/stores/plans'

/**
 * Fetches all plan types (regular, legacy, upsell, affiliate).
 * This data is needed across most pages for membership options.
 */
export const fetchPlans = async function () {
  try {
    const plansStore = usePlansStore()
    await plansStore.fetchAllPlans()
  } catch (e) {
    console.error(e)
    // redirect to NotFoundView
    return 'not-found'
  }
}
